export default "__VITE_ASSET__f1b89f89__"